export default "---\ntitle: Device Software\n---\n\nThese terms and technologies are used for software that runs on GPU — the\n\"device\" in NVIDIA's lingo.\n"